export const DRAWER_TABS = [
  { id: 'info', label: 'Informations' },
  { id: 'assign', label: 'Affectation' },
  { id: 'caps', label: 'Capacités' },
  { id: 'journal', label: 'Journal' },
  { id: 'history', label: 'Historique' },
];

/**
 * Onglets fiche matériel U3.
 */
export default function MaterielDrawerTabs({ active, onChange }) {
  return (
    <nav
      className="flex gap-0 border-b border-gray-100 px-2 pt-2 overflow-x-auto"
      aria-label="Onglets fiche matériel"
    >
      {DRAWER_TABS.map((tab) => {
        const selected = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange?.(tab.id)}
            aria-selected={selected}
            className={`px-3 py-2 text-xs font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${
              selected
                ? 'border-primary-500 text-primary-700'
                : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
